<template>
  <div class="review-video">
    <div class="review">
      <van-list @load="onLoad" v-model="loading" :finished="finished" finished-text="没有更多了">
        <div class="review-content">
          <div class="contentList">
            <div class="video" v-for="(item, index) in videoList" :key="index" @click="checked(item, index)">
              <div class="iconBox">
                <van-icon class="icon" :class="ind === index ? 'play' : ''" name="play-circle-o" size="16px" color="#fff" />
                <img :src="getPoster(item)" alt="" />
              </div>
              <!-- van-multi-ellipsis--l2 -->
              <div class="detail" :class="ind === index ? 'hover' : ''">
                <div class="content van-multi-ellipsis--l2" :class="ind === index ? 'fontColor' : ''">{{ item.videoName }}</div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div>
      <van-button v-if="ind !== ''" @click="reback" class="rebtn" color="linear-gradient(to right, #00C6FC, #0094F7)"> 返回直播 </van-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Review',
  data() {
    return {
      api: $$.module.interview.$api,
      pageNo: 1,
      loading: false,
      ind: '',
      finished: false,
      backFlg: true,
      value: {},
      videoList: []
    };
  },
  methods: {
    getPoster(value) {
      return value.videoUrlJson?.poster || value.videoUrl + '?vframe/jpg/offset/0';
    },
    reback() {
      this.backFlg = false;
      this.ind = '';
      this.$emit('reback', this.backFlg);
    },
    checked(value, idx) {
      this.ind = idx;
      const stream = {
        poster: value.videoUrlJson && value.videoUrlJson.poster ? value.videoUrlJson.poster.poster || '' : value.videoUrl + '?vframe/jpg/offset/0',
        sources: [
          {
            src: value.videoUrl,
            type: 'video/mp4'
          }
        ]
      };
      this.$emit('checked', stream);
    },
    onLoad() {
      this.api.replayVideo({
        data: {
          roomId: $$.module.data.room.roomId,
          pageNo: this.pageNo,
          pageSize: 5
        },
        success: (data) => {
          this.videoList = this.videoList.concat(data.records);
          data.totalPage > this.pageNo && this.pageNo++;
          this.loading = false;

          if (this.videoList.length >= data.totalCount) {
            this.finished = true;
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped></style>
